import { SvgIcon, SvgIconProps } from '@mui/material';

export function ArrowDownIcon(props?: SvgIconProps) {
	return (
		<SvgIcon
			width='14'
			height='8'
			viewBox='0 0 14 8'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path d='M7 8L0.937822 2L13.0622 2L7 8Z' />
		</SvgIcon>
	);
}
